export default "__VITE_ASSET__DfGbOBDx__"